import { render, staticRenderFns } from "./form-view.vue?vue&type=template&id=6c2b35e4&scoped=true"
import script from "./form-view.vue?vue&type=script&lang=js"
export * from "./form-view.vue?vue&type=script&lang=js"
import style0 from "./form-view.vue?vue&type=style&index=0&id=6c2b35e4&prod&lang=css"
import style1 from "./form-view.vue?vue&type=style&index=1&id=6c2b35e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2b35e4",
  null
  
)

export default component.exports